export const ICON_CART = 'Cart'
